import type { TourDefinition } from '../tours.types';

export const DASHBOARD_TOUR: TourDefinition = {
  id: 'dashboard_help',
  route: '/dashboard/default',
  remember: true,
  steps: [
    // Paso introductorio (sin elemento)
    {
      popover: {
        title: 'Panel principal',
        description:
          'Desde aquí puedes iniciar procesos de firma, dar seguimiento a su avance y acceder a los documentos finalizados.',
      },
    },

    {
      element: '[data-tour="card-firmar"]',
      popover: {
        title: 'Firmar documentos',
        description:
          'Inicia un proceso de firma cargando uno o varios documentos. Puedes firmar tú mismo o solicitar la firma a otros usuarios o grupos.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="card-plantillas"]',
      popover: {
        title: 'Plantillas de documentos',
        description:
          'Crea documentos base con áreas de firma predefinidas para reutilizarlos en futuros procesos.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="card-perfil"]',
      popover: {
        title: 'Mi perfil y credenciales',
        description:
          'Administra tu información personal, certificados de firma y los grupos a los que perteneces.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="docs-pendientes"]',
      popover: {
        title: 'Documentos pendientes',
        description:
          'Aquí ves los documentos que requieren tu firma o procesos que dejaste pendientes.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="avance-firmas"]',
      popover: {
        title: 'Avance de firmas',
        description:
          'Revisa el progreso de los procesos de firma que creaste y el estado de cada firmante.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="pendientes-reintentos-firmas"]',
      popover: {
        title: 'Pendientes de reintento',
        description:
          'Aquí ves los documentos que requieren que realices una acción de reintento para poder completarse.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="lotes-completados"]',
      popover: {
        title: 'Procesos finalizados',
        description:
          'Accede a los documentos ya firmados y descárgalos cuando lo necesites.',
        side: 'top',
        align: 'start',
      },
    },
  ],
};
